import React from "react";
import { Sprout, Package, ShieldCheck, Sparkles } from "lucide-react";

const CATALOG = [
  { name: "Urea 46% N", brand: "IFFCO", pack: "45 kg bag", price: 266, tag: "Nitrogen", img: "https://images.unsplash.com/photo-1596496638037-4c65e83ed5b7?w=600&q=80" },
  { name: "DAP 18-46-0", brand: "Kribhco", pack: "50 kg bag", price: 1350, tag: "Phosphorus", img: "https://images.unsplash.com/photo-1615485500704-8e990f9900f7?w=600&q=80" },
  { name: "NPK 20-20-20", brand: "Coromandel", pack: "25 kg bag", price: 1720, tag: "Balanced", img: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&q=80" },
  { name: "Potash MOP", brand: "IPL", pack: "50 kg bag", price: 1700, tag: "Potassium", img: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&q=80" },
  { name: "Zinc Sulphate", brand: "Rallis", pack: "5 kg", price: 320, tag: "Micronutrient", img: "https://images.unsplash.com/photo-1596496638037-4c65e83ed5b7?w=600&q=80" },
  { name: "Vermicompost Organic", brand: "Local Coop", pack: "40 kg bag", price: 480, tag: "Organic", img: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&q=80" },
];

const Khaad = () => (
  <div data-testid="khaad-page" className="bg-[#FDFBF7]">
    <section className="border-b border-stone-200 bg-gradient-to-b from-[#F4F1EA] to-[#FDFBF7]">
      <div className="container-gc px-4 sm:px-6 py-12 sm:py-16">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-stone-200 text-xs font-medium text-[#1E4D2B] mb-5">
          <Sprout size={14} /> Khaad · Fertilizers
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-stone-900 leading-tight">Khaad Catalog</h1>
        <p className="mt-4 text-lg text-stone-700 max-w-2xl leading-relaxed">
          Government-authorised fertilizers for garlic cultivation. Prices are indicative — final rate at licensed retailer with Aadhaar-linked PoS.
        </p>
        <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-100 text-amber-800 text-xs font-semibold">
          <Sparkles size={14} /> Ordering flow — Coming Soon
        </div>
      </div>
    </section>

    <section className="container-gc px-4 sm:px-6 py-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {CATALOG.map((p, i) => (
        <article key={i} data-testid={`khaad-item-${i}`} className="card-gc overflow-hidden flex flex-col hover:shadow-md transition-shadow">
          <div className="aspect-[4/3] bg-stone-100 overflow-hidden">
            <img src={p.img} alt={p.name} className="w-full h-full object-cover" loading="lazy" />
          </div>
          <div className="p-5 flex flex-col flex-1">
            <div className="flex items-center justify-between gap-2 mb-2">
              <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-[#F4F1EA] text-[#1E4D2B]">{p.tag}</span>
              <span className="text-xs text-stone-500">{p.brand}</span>
            </div>
            <h3 className="text-lg font-bold text-stone-900">{p.name}</h3>
            <p className="text-sm text-stone-600 mt-0.5 flex items-center gap-1"><Package size={13} /> {p.pack}</p>
            <div className="mt-3 text-2xl font-bold text-[#1E4D2B]">₹{p.price}<span className="text-xs text-stone-500 font-normal"> /bag</span></div>
            <button disabled className="btn-primary mt-4 !bg-stone-300 hover:!bg-stone-300 cursor-not-allowed opacity-70">
              <ShieldCheck size={16} /> Coming Soon
            </button>
          </div>
        </article>
      ))}
    </section>
  </div>
);

export default Khaad;
